const o = {
  position: "absolute",
  width: "100%",
  minWidth: 45,
  zIndex: "dropdownMenu"
}, t = {
  py: 2
}, e = {
  width: "100%"
}, n = {
  bg: "white",
  borderRadius: "sm",
  boxShadow: "md"
}, d = {
  display: "flex",
  flexDirection: "column",
  gap: 1,
  maxHeight: "30vh",
  p: 2,
  overflow: "auto"
}, r = {
  px: 4,
  pt: 2,
  pb: 0
}, s = {
  p: 2
}, p = {
  display: "flex",
  alignItems: "center",
  flexShrink: 0,
  minHeight: 8,
  py: 1,
  px: 2,
  borderRadius: "xs",
  cursor: "pointer",
  transition: "all",
  overflowWrap: "break-word",
  svg: {
    flexShrink: 0
  }
}, i = {
  bg: "secondary"
}, a = {
  bg: "secondary"
}, l = {
  bg: "transparent",
  cursor: "not-allowed",
  color: "disabledText",
  "&:hover": {
    bg: "transparent"
  }
}, w = {
  dropdownAbsoluteWrapper: o,
  dropdownAbsoluteWrapperOpen: t,
  dropdownAbsoluteContent: e,
  dropdownListContent: n,
  dropdownListViewport: d,
  dropdownListHeader: r,
  dropdownListFooter: s,
  dropdownListItem: p,
  dropdownListHighlightedItem: i,
  dropdownListSelectedItem: a,
  dropdownListDisabledItem: l
};
export {
  w as dropdownsTheme
};
